import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=5ffd09d9"
import script from "./BaseFormInput.vue?vue&type=script&lang=js"
export * from "./BaseFormInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=5ffd09d9&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports